<div class=" h-full sm:pt-5 pt-8">
  @if(!sollecito){
    <div class="pl-3">
      <!--  label="Stampa Estratto Conto" -->
      <p-button
        icon="pi pi-print"
        (click)="stampaResoconto()"
        [disabled]="role_service.isConsultazioneRole()"
        pTooltip="Stampa Resoconto Contabile"
        tooltipPosition="bottom"></p-button>
    </div>
  }

  <p-tabView>
    <!-- pagamenti -->
    <p-tabPanel header="Pagamenti">
      <div class="backPanel border-round-3xl">
        <div class="px-5 pt-3 pb-5">
          <app-tabella-pagamenti [data]="listaData"></app-tabella-pagamenti>
        </div>
      </div>
    </p-tabPanel>

    <!-- anagrafica -->
    <p-tabPanel header="Anagrafica">
      <div class="flex flex-column backPanel border-round-3xl px-5 pt-5 pb-2">
        <div class="flex flex-wrap">
          <!-- informazioni -->
          <p-fieldset legend="INFORMAZIONI" class="customFieldset mb-6 w-full">
            <div class="flex flex-wrap pt-3">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="codiceFiscale" [value]="iscrittoReadonlyData?.codiceFiscale" readonly/>
                  <label class="pl-1" for="codiceFiscale">Codice Fiscale</label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="dataNascita" [value]="iscrittoReadonlyData?.dataNascita | date:'dd/MM/yyyy'" readonly/>
                  <label class="pl-1" for="dataNascita">Data Nascita</label>
                </span>
              </div>
            </div>

            <div class="flex flex-wrap">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="nome" [value]="iscrittoReadonlyData?.nome" readonly/>
                  <label class="pl-1" for="nome">Nome</label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="cognome" [value]="iscrittoReadonlyData?.cognome" readonly/>
                  <label class="pl-1" for="cognome">Cognome</label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="sesso" [value]="iscrittoReadonlyData?.sesso === 'F' ? 'Femmina' : 'Maschio'" readonly/>
                  <label class="pl-1" for="sesso">Sesso</label>
                </span>
              </div>
            </div>

            <div class="flex flex-wrap">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="alias" [value]="iscrittoReadonlyData?.alias" readonly/>
                  <label class="pl-1" for="alias">Alias</label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="sessoAlias" [value]="iscrittoReadonlyData?.sessoAlias === 'F' ? 'Femmina' : 'Maschio'" readonly/>
                  <label class="pl-1" for="sessoAlias">Sesso Alias</label>
                </span>
              </div>
            </div>

            <div class="flex flex-wrap">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="luogoNascita" [value]="iscrittoReadonlyData?.luogoNascita" readonly/>
                  <label class="pl-1" for="luogoNascita">Luogo di Nascita</label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="provinciaNascita" [value]="iscrittoReadonlyData?.provinciaNascita" readonly/>
                  <label class="pl-1" for="provinciaNascita">Provincia di Nascita</label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="cittadinanza" [value]="iscrittoReadonlyData?.cittadinanza" readonly/>
                  <label class="pl-1" for="cittadinanza">Cittadinanza</label>
                </span>
              </div>
            </div>

            <div class="flex flex-wrap mb-3 gap-4">
              <div class="flex align-items-center pl-3 mb-3">
                <p-checkbox class="mr-1" [binary]="true" inputId="permessoSoggiorno" [(ngModel)]="flagPermessoDiSoggiorno" readonly></p-checkbox>
                <label class="checkboxLabelCustom" for="permessoSoggiorno">Permesso di Soggiorno</label>
              </div>
              <div>
                <span class="p-float-label px-3 mb-3">
                  <input class="px-0" pInputText id="permessoSoggiornoScadenza" [value]="iscrittoReadonlyData?.permessoSoggiornoScadenza | date:'dd/MM/yyyy'" readonly/>
                  <label class="pl-1" for="permessoSoggiornoScadenza">Scadenza P.S.</label>
                </span>
              </div>
              <div class="flex align-items-center pl-3 mb-3">
                <p-checkbox class="mr-1" [binary]="true" inputId="permessoSoggiornoIllimitato" [(ngModel)]="flagPermessoDiSoggiornoIllimitato" readonly></p-checkbox>
                <label class="checkboxLabelCustom" for="permessoSoggiornoIllimitato">Permesso di Soggiorno Illimitato</label>
              </div>
            </div>
          </p-fieldset>
        </div>

        <!-- residenza -->
        <p-fieldset legend="RESIDENZA" class="customFieldset mb-6">
          <div class="flex flex-wrap pt-3">
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="residenzaIndirizzo" [value]="iscrittoReadonlyData?.residenzaIndirizzo" readonly/>
                <label class="pl-1" for="residenzaIndirizzo">Indirizzo</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="residenzaCap" [value]="iscrittoReadonlyData?.residenzaCap" readonly/>
                <label class="pl-1" for="residenzaCap">CAP</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="residenzaComune" [value]="iscrittoReadonlyData?.residenzaComune" readonly/>
                <label class="pl-1" for="residenzaComune">Comune</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="residenzaProvincia" [value]="iscrittoReadonlyData?.residenzaProvincia" readonly/>
                <label class="pl-1" for="residenzaProvincia">Provincia</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="residenzaStato" [value]="iscrittoReadonlyData?.residenzaStato" readonly/>
                <label class="pl-1" for="residenzaStato">Stato</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="residenzaLuogo" [value]="iscrittoReadonlyData?.residenzaLuogo" readonly/>
                <label class="pl-1" for="residenzaLuogo">Residenza Luogo</label>
              </span>
            </div>
          </div>
        </p-fieldset>

        <!-- domicilio -->
        <p-fieldset legend="DOMICILIO" class="customFieldset mb-6">
          <div class="flex flex-wrap pt-3">
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="domicilioIndirizzo" [value]="iscrittoReadonlyData?.domicilioIndirizzo" readonly/>
                <label class="pl-1" for="domicilioIndirizzo">Indirizzo</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="domicilioCap" [value]="iscrittoReadonlyData?.domicilioCap" readonly/>
                <label class="pl-1" for="domicilioCap">CAP</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="domicilioComune" [value]="iscrittoReadonlyData?.domicilioComune" readonly/>
                <label class="pl-1" for="domicilioComune">Comune</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="domicilioProvincia" [value]="iscrittoReadonlyData?.domicilioProvincia" readonly/>
                <label class="pl-1" for="domicilioProvincia">Provincia</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="domicilioLuogo" [value]="iscrittoReadonlyData?.domicilioLuogo" readonly/>
                <label class="pl-1" for="domicilioLuogo">Domicilio Luogo</label>
              </span>
            </div>
          </div>
        </p-fieldset>

        <!-- contatti -->
        <p-fieldset legend="CONTATTI" class="customFieldset mb-6">
          <div class="flex flex-wrap pt-3">
            <div class="md:mr-5">
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="email" [value]="iscrittoReadonlyData?.email" readonly/>
                <label class="pl-1" for="email">E-mail</label>
              </span>
            </div>
            <div class="md:mr-5">
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="pec" [value]="iscrittoReadonlyData?.pec" readonly/>
                <label class="pl-1" for="pec">PEC</label>
              </span>
            </div>
            <div class="md:mr-5">
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="telefonoPrincipale" [value]="iscrittoReadonlyData?.numeroPrincipale" readonly/>
                <label class="pl-1" for="telefonoPrincipale">Numero Principale</label>
              </span>
            </div>
          </div>
        </p-fieldset>
      </div>
    </p-tabPanel>

    <!-- albo -->
    <p-tabPanel header="Albo">
      <div class="flex flex-column backPanel border-round-3xl px-5 pt-5 pb-2">
        <!-- ISCRIZIONE FIELDSET -->
        <p-fieldset legend="ISCRIZIONE" class="customFieldset mb-6">
          <div class="flex flex-wrap pt-3">
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="numeroIscrizione" [value]="iscrittoReadonlyData?.numeroIscrizione" readonly/>
                <label class="pl-1" for="numeroIscrizione">N° Iscrizione</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="dataIscrizione" [value]="iscrittoReadonlyData?.dataIscrizione | date:'dd/MM/yyyy'" readonly/>
                <label class="pl-1" for="dataIscrizione">Data Iscrizione</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="sezioneAlbo" [value]="'Sezione ' + iscrittoReadonlyData?.sezioneAlbo" readonly/>
                <label class="pl-1" for="sezioneAlbo">Sezione</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="domandaProtocollo" [value]="iscrittoReadonlyData?.domandaProtocollo" readonly/>
                <label class="pl-1" for="domandaProtocollo">Protocollo Domanda</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="domandaData" [value]="iscrittoReadonlyData?.domandaData | date:'dd/MM/yyyy'" readonly/>
                <label class="pl-1" for="domandaData">Data Domanda</label>
              </span>
            </div>
          </div>
        </p-fieldset>

        <!-- STATO ISCRITTO FIELDSET -->
        <p-fieldset legend="STATO ISCRITTO" class="customFieldset mb-6">
          <div class="flex flex-wrap pt-3">
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="statoIscritto" [value]="iscrittoReadonlyData?.statoIscritto" readonly/>
                <label class="pl-1" for="statoIscritto">Stato Iscritto</label>
              </span>
            </div>
          </div>

          @if(iscrittoReadonlyData?.statoIscritto === "SOSPESO"){
            <div class="flex flex-wrap mb-1">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="sospensioneDal" [value]="iscrittoReadonlyData?.sospensioneDal | date:'dd/MM/yyyy'" readonly/>
                  <label class="pl-1" for="sospensioneDal">Sospensione Dal</label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="sospensioneAl" [value]="iscrittoReadonlyData?.sospensioneAl | date:'dd/MM/yyyy'" readonly/>
                  <label class="pl-1" for="sospensioneAl">Fino Al</label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="articolo26" [value]="iscrittoReadonlyData?.motivoSospensione" readonly/>
                  <label class="pl-1" for="articolo26">Motivo Sospensione</label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="procedimentoDisciplinareInCorso" [value]="iscrittoReadonlyData?.procedimentoDisciplinare" readonly/>
                  <label class="pl-1" for="procedimentoDisciplinareInCorso">Procedimento Disciplinare</label>
                </span>
              </div>
            </div>
          }

          <div class="flex">
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="trasferimentoDaOrdine" [value]="iscrittoReadonlyData?.trasferimentoDaOrdine" readonly/>
                <label class="pl-1" for="trasferimentoDaOrdine">Trasferimento Da</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="trasferimentoEntrataData" [value]="iscrittoReadonlyData?.trasferimentoEntrataData | date:'dd/MM/yyyy'" readonly/>
                <label class="pl-1" for="trasferimentoEntrataData">Trasf. Entrata Data</label>
              </span>
            </div>
          </div>

          @if(iscrittoReadonlyData?.statoIscritto === "TRASFERIMENTO"){
            <div class="flex">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="trasferimentoAOrdine" [value]="iscrittoReadonlyData?.trasferimentoAOrdine" readonly/>
                  <label class="pl-1" for="trasferimentoAOrdine">Trasferimento A</label>
                </span>
              </div>
              <div class="">
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="trasferimentoUscitaData" [value]="iscrittoReadonlyData?.trasferimentoUscitaData | date:'dd/MM/yyyy'" readonly/>
                  <label class="pl-1" for="trasferimentoUscitaData">Trasf. Uscita Data</label>
                </span>
              </div>
            </div>
          }

        </p-fieldset>

        <!-- RUOLI FIELDSET -->
        <p-fieldset legend="RUOLI PROFESSIONALI" class="customFieldset mb-6">
          <div class="flex flex-wrap pt-3">
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="ctu" [value]="iscrittoReadonlyData?.ctu" readonly/>
                <label class="pl-1" for="ctu">C.T.U.</label>
              </span>
            </div>
            <div>
              <span class="p-float-label px-3 mb-6">
                <input class="px-0" pInputText id="perito" [value]="iscrittoReadonlyData?.perito" readonly/>
                <label class="pl-1" for="perito">Perito</label>
              </span>
            </div>
          </div>

          <div class="flex flex-wrap mb-6">
            <div class="px-3">
              <p-checkbox class="mr-1" [binary]="true" inputId="articolo82" [(ngModel)]="flag82" readonly></p-checkbox>
              <label class="checkboxLabelCustom" for="articolo82">Articolo 8.2</label>
            </div>
            <div class="px-3">
              <p-checkbox class="mr-1" [binary]="true" inputId="dipendentePubblico" [(ngModel)]="flagDP" readonly></p-checkbox>
              <label class="checkboxLabelCustom" for="dipendentePubblico">Dipendente Pubblico</label>
            </div>
          </div>

          <div class="flex flex-wrap mb-3">
            <div class="flex align-items-center pl-3 mb-3">
              <p-checkbox class="mr-1" [binary]="true" inputId="professoreUniversitario" [(ngModel)]="flagPU" readonly></p-checkbox>
              <label class="checkboxLabelCustom" for="professoreUniversitario">Professore Universitario</label>
            </div>
            <div class="uniCustom w-full lg:w-6">
              <span class="p-float-label px-3 mb-3">
                <input class="px-0" pInputText id="professorePressoUniversita" [value]="iscrittoReadonlyData?.professoreUniversita" readonly/>
                <label class="pl-1" for="professorePressoUniversita">Professore Università</label>
              </span>
            </div>
          </div>
        </p-fieldset>

      </div>

    </p-tabPanel>

  </p-tabView>

  @if(sollecito){
    <div class="absolute top-0 right-0 mr-6 mt-8 pt-5">
      <p-menu #menu [model]="vociStampa" [popup]="true" appendTo="body"></p-menu>
      <button
        pButton
        type="button"
        (click)="menu.toggle($event)"
        icon="pi pi-print"
        [disabled]="!role_service.isContabilitaOrConsultazione()"
        pTooltip="Stampe"
        tooltipPosition="bottom"></button>
    </div>
  }


  <p-toast position="bottom-center"></p-toast>
</div>
